import { PaymentDashboard } from "@/features/payments";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod/v4";
import { PAYMENT_STATUSES } from "../../../api/types";
import { isomorphicHttpClient } from "../../../httpClient";
import { verifyRoles } from "../../../utils/verifyRoles";

const paymentsFiltersSearchParamsSchema = z.object({
  tenantId: z.string().default("").catch(""),
  status: z.array(z.enum(PAYMENT_STATUSES)).default([]).catch([]),
  minAmount: z.number().optional().catch(undefined),
  maxAmount: z.number().optional().catch(undefined),
  startDate: z.iso.datetime().optional().catch(undefined),
  endDate: z.iso.datetime().optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/payments/")({
  component: PaymentDashboard,
  head: () => ({
    meta: [{ title: "Pagamentos - Backoffice Detentora Iniciador" }],
  }),
  validateSearch: paymentsFiltersSearchParamsSchema,
  search: {
    middlewares: [
      stripSearchParams(paymentsFiltersSearchParamsSchema.parse({})),
    ],
  },
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["tenants"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/tenants");

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
